// Styles
import '../scss/index.scss';
import '/vendor/pages-v15/index';

$(document).ready(function () {
  $('.burger-trigger').on('click', function () {
    const $nav = $('.mobile-nav');
    $(this).toggleClass('active');

    if ($nav.is(':hidden')) {
      $nav.css('display', 'flex').hide().slideDown(300);
    } else {
      $nav.slideUp(300);
    }
  });

  $('.mobile-nav a').on('click', function () {
    $('.burger-trigger').removeClass('active');
    $('.mobile-nav').slideUp(300);
  });

  $(window).on('resize', function () {
    if ($(window).width() > 768) {
      $('.mobile-nav').removeAttr('style');
      $('.burger-trigger').removeClass('active');
    }
  });
});
